import React from "react";
import { DetailField } from "../../molecules";
import { Card, FieldsGrid } from "./ConnectionInfoCard.styles";
import type { ConnectionInfoCardProps } from "./ConnectionInfoCard.types";

/**
 * Connection-info card on the Connection Detail page (UI-4).
 * Relational connectors show six setup-time fields; file connectors (CSV)
 * show three KPI-style boxed fields using the same DetailField primitive.
 */
export const ConnectionInfoCard: React.FC<ConnectionInfoCardProps> = (props) => {
  if (props.variant === "file") {
    const { fileType, createdBy, lastUpdatedOn, className } = props;
    return (
      <Card className={className} aria-label="Connection details">
        <FieldsGrid>
          <DetailField boxed label="File type" value={fileType} />
          <DetailField boxed label="Created by" value={createdBy} />
          <DetailField boxed label="Last updated on" value={lastUpdatedOn} />
        </FieldsGrid>
      </Card>
    );
  }

  const {
    connectionName,
    authType,
    environment,
    authentication,
    createdBy,
    createdOn,
    className,
  } = props;

  return (
    <Card className={className} aria-label="Connection details">
      <FieldsGrid>
        <DetailField boxed label="Connection name" value={connectionName} />
        <DetailField boxed label="Auth type" value={authType} />
        <DetailField boxed label="Environment" value={environment} />
        <DetailField boxed label="Authentication" value={authentication} />
        <DetailField boxed label="Created by" value={createdBy} />
        <DetailField boxed label="Created on" value={createdOn} />
      </FieldsGrid>
    </Card>
  );
};

export default ConnectionInfoCard;
